import { gql } from '__generated__';

export default gql(`
  query GetEventReviews($id: ID!, $limit: Int) {
    event(id: $id) {
      id
      review_average_rating
      review_aspect_counts {
        type
        count
      }
      reviews(per_page: $limit) {
        total
        data {
          ...GetEvent_ReviewFields
        }
      }
    }
  }
`);
